export default "__VITE_ASSET__BXtoAd05__"